// Polish translations (Polski)
export const pl = {
  // Navigation
  nav: {
    home: "Strona Główna",
    rooms: "Pokoje",
    amenities: "Udogodnienia",
    gallery: "Galeria",
    virtualTour: "Wirtualna Wycieczka",
    location: "Lokalizacja",
    contact: "Kontakt",
    bookNow: "Zarezerwuj"
  },
  
  // Hero
  hero: {
    tagline: "Rodzinny hotel 3*, 2 minuty od plaży Velika Plaža, Ulcinj",
    description: "Prosty, rodzinny hotel 3* na Kepi i Gjeranave, około 2 minuty pieszo od piasku na początku Velika Plaža, 12-kilometrowej plaży Ulcinja. Śniadanie, kolacja, basen, Wi-Fi i garaż w cenie. Pokoje są czyste i funkcjonalne, bez luksusu — większość ma balkon, wiele z widokiem na morze.",
    exploreRooms: "Odkryj Pokoje",
    viewGallery: "Zobacz Galerię",
    veryGood: "Bardzo Dobrze",
    reviews: "opinii",
    starHotel: "Hotel 3-gwiazdkowy",
    bookDirect: "Zarezerwuj bezpośrednio i oszczędzaj",
    bestPrice: "Taniej niż na Booking.com za ten sam pokój",
    freeCancellation: "Bezpłatne anulowanie taryf elastycznych",
    noBookingFees: "Bez opłat za rezerwację",
    checkAvailability: "Sprawdź dostępność →"
  },
  
  // Booking
  booking: {
    checkAvailability: "Sprawdź Dostępność i Zarezerwuj",
    checkIn: "Zameldowanie",
    checkOut: "Wymeldowanie",
    adults: "Dorośli",
    children: "Dzieci",
    adult: "Dorosły",
    child: "Dziecko",
    searchAvailability: "Szukaj Dostępności",
    secureBooking: "Bezpieczna rezerwacja • Gwarancja najlepszej ceny • Bezpłatne anulowanie większości pokoi",
    freeCancellation: "Bezpłatne anulowanie większości rezerwacji"
  },
  
  // Rooms
  rooms: {
    title: "Proste, czyste pokoje przy plaży",
    subtitle: "Zakwaterowanie",
    description: "13 typów pokoi — od małej jedynki po apartament z dwiema sypialniami. Każdy ma klimatyzację, własną łazienkę i darmowe Wi-Fi; większość balkon. Meble są funkcjonalne, nie designerskie.",
    viewDetails: "Zobacz Szczegóły",
    bookNow: "Zarezerwuj",
    perNight: "/noc",
    guests: "Gości",
    backToRooms: "Powrót do Wszystkich Pokoi",
    roomAmenities: "Udogodnienia w Pokoju",
    standardFeatures: "Standardowe Wyposażenie"
  },
  
  // Room Names (Polish)
  roomNames: {
    room1: "Pokój dwuosobowy z widokiem na morze i balkonem",
    room2: "Pokój dwuosobowy przy basenie",
    room3: "Ekonomiczny pokój dwuosobowy z balkonem (bez widoku)",
    room4: "Pokój z dwoma łóżkami, widokiem na morze i wspólnym tarasem",
    room5: "Pokój Executive dla trzech osób z widokiem na morze i balkonem",
    room6: "Pokój dwuosobowy z dodatkowym łóżkiem - widok na morze i balkon",
    room7: "Dwupokojowy apartament rodzinny",
    room8: "Pokój rodzinny ze wspólnym tarasem",
    room9: "Pokój rodzinny z tarasem",
    room10: "Mały pokój jednoosobowy",
    room11: "Pokój trzyosobowy z balkonem",
    room12: "Pokój rodzinny z widokiem na góry",
    room13: "Apartament z jedną sypialnią"
  },
  
  // Amenities
  amenities: {
    title: "Udogodnienia Hotelu",
    subtitle: "Co Oferujemy",
    beachfront: "Lokalizacja na Plaży",
    beachfrontDesc: "Bezpośredni dostęp do Long Beach",
    childrenPool: "Basen dla Dzieci",
    childrenPoolDesc: "Bezpieczny basen dla rodzin",
    restaurant: "Restauracja i Kawiarnia",
    restaurantDesc: "Kuchnia bałkańska · bez alkoholu",
    wifi: "Bezpłatne WiFi",
    wifiDesc: "Szybki internet",
    parking: "Bezpłatny Parking",
    parkingDesc: "Bezpieczny parking",
    shuttle: "Transfer z Lotniska",
    shuttleDesc: "€80 z Podgoricy i Tivatu (na życzenie)",
    frontDesk: "Całodobowa Recepcja",
    frontDeskDesc: "Serwis 24/7",
    elevator: "Winda",
    elevatorDesc: "Wszystkie piętra"
  },
  
  // Gallery
  gallery: {
    intro: "Odkryj piękno Hotelu La Rosa Negra i urok Ulcinja.",
    title: "Galeria Zdjęć",
    subtitle: "Odkryj Nasz Hotel",
    all: "Wszystkie",
    rooms: "Pokoje",
    pool: "Basen",
    beach: "Plaża",
    restaurant: "Restauracja",
    exterior: "Zewnątrz"
  },
  
  // Virtual Tour
  virtualTour: {
    title: "Wirtualna Wycieczka 360°",
    subtitle: "Poznaj Nasz Hotel",
    description: "Wybierz się na wirtualny spacer po naszym pięknym hotelu"
  },
  
  // Location
  location: {
    title: "Nasza Lokalizacja",
    subtitle: "Znajdź Nas",
    address: "Adres",
    nearbyAttractions: "Atrakcje w Pobliżu"
  },
  
  // Contact
  contact: {
    title: "Skontaktuj się z Nami",
    subtitle: "Napisz do Nas",
    name: "Imię",
    email: "Email",
    message: "Wiadomość",
    send: "Wyślij Wiadomość",
    phone: "Telefon",
    whatsapp: "WhatsApp"
  },
  
  // FAQ
  faq: {
    intro: "Odpowiedzi na najczęstsze pytania o Hotel La Rosa Negra.",
    title: "Często Zadawane Pytania",
    subtitle: "FAQ"
  },
  
  // Footer
  footer: {
    quickLinks: "Szybkie Linki",
    contactInfo: "Informacje Kontaktowe",
    followUs: "Śledź Nas",
    rights: "Wszelkie prawa zastrzeżone",
    starHotel: "gwiazdkowy Hotel",
    description: "Odkryj idealne połączenie śródziemnomorskiego uroku i nowoczesnego komfortu bezpośrednio przy Velika Plaža (Długiej Plaży), Ulcinj, Czarnogóra.",
    rooms: "Pokoje i Apartamenty",
    amenities: "Udogodnienia",
    gallery: "Galeria",
    location: "Lokalizacja",
    reviews: "Opinie",
    legal: "Informacje prawne",
    privacy: "Polityka prywatności",
    terms: "Regulamin",
    cookies: "Polityka cookies",
    cancellation: "Polityka anulowania"
  },

  // Smart language-hint toast
  langHint: {
    message: "Ta strona jest również dostępna w języku polskim",
    switch: "Zmień",
    dismiss: "Zamknij"
  },
  
  // Why Book Direct
  whyBookDirect: {
    eyebrow: "Rezerwacja bezpośrednia",
    heading: "Dlaczego rezerwować bezpośrednio?",
    lead: "Tu jest taniej niż na Booking.com i rozmawiasz bezpośrednio z nami — oto dokładnie, co dostajesz",
    b1t: "Taniej niż na Booking.com",
    b1d: "Nasza cena bezpośrednia jest o 10% niższa od naszej ceny na Booking.com za ten sam pokój i termin. Znalazłeś taniej tam? Wyślij link, wyrównamy.",
    b2t: "10% zniżki",
    b2d: "Te 10% jest już w cenie, którą widzisz — bez kodu i dodatkowych opłat.",
    b3t: "Jasne warunki anulowania",
    b3d: "Taryfy elastyczne można anulować bezpłatnie do daty pokazanej przy rezerwacji; taryfy bezzwrotne są wyraźnie oznaczone przed płatnością.",
    b4t: "Odpowiada człowiek",
    b4d: "WhatsApp, telefon lub e-mail — recepcja zwykle odpowiada w ciągu kilku godzin, 08:00–23:00.",
    cta: "Zarezerwuj bezpośrednio i oszczędzaj"
  },

  // Amenities section headings/CTA
  amenitiesSection: {
    eyebrow: "Udogodnienia",
    heading: "Co ma hotel",
    lead: "Udogodnienia, które naprawdę są — ni mniej, ni więcej.",
    ctaTitle: "Pytania przed rezerwacją?",
    ctaLead: "Pytaj o pokoje, plażę lub dojazd — odpowiadamy szczerze.",
    ctaButton: "Skontaktuj się z concierge"
  },

  // Contact section
  contactSection: {
    eyebrow: "Skontaktuj się",
    heading: "Napisz do nas",
    lead: "Masz pytania? Jesteśmy tutaj, aby pomóc. Skontaktuj się z nami o dowolnej porze.",
    addressLabel: "Adres",
    phoneLabel: "Telefon",
    emailLabel: "Email",
    receptionLabel: "Godziny recepcji",
    reception247: "24/7 - Zawsze jesteśmy dla Ciebie",
    whatsappBtn: "Czat na WhatsApp",
    emailBtn: "Wyślij email",
    bookDirectTitle: "Zarezerwuj bezpośrednio i oszczędzaj",
    bookDirectDesc: "Otrzymaj 10% zniżki przy rezerwacji przez naszą stronę",
    checkAvailability: "Sprawdź dostępność",
    whatsappPrefill: "Dzień dobry, chciałbym zapytać o Hotel La Rosa Negra"
  },

  // Reviews section
  reviews: {
    eyebrow: "Opinie gości",
    heading: "Co mówią goście — bez zmian",
    lead: "Opinie są kopiowane z Booking.com tak, jak zostały napisane, także te krytyczne. Oceń sam.",
    veryGood: "Bardzo dobrze",
    reviewsCount: "opinii",
    starHotel: "Hotel 3-gwiazdkowy",
    readMoreOn: "Przeczytaj więcej opinii na",
    translatedFrom: "Przetłumaczono z: {lang}",
    showOriginal: "Pokaż oryginał",
    showTranslation: "Pokaż tłumaczenie"
  },

  // Handoff
  handoff: {
    prompt: "Wolisz porozmawiać z naszym zespołem?",
    button: "Kontynuuj na WhatsApp",
    prefix: "Dzień dobry, Hotel La Rosa Negra! Rozmawiałem/am z Waszym wirtualnym asystentem i chciałbym/chciałabym kontynuować z osobą."
  },

  // Common
  common: {
    learnMore: "Dowiedz się Więcej",
    seeAll: "Zobacz Wszystko",
    close: "Zamknij",
    loading: "Ładowanie..."
  }
};
